// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1850": "e56fa031","4816": "a7d218b9","660": "b0da6b42","718": "95fe9399","9820": "f2aa62d5",}[chunkId] + ".css"
}